import {
  OperatingAreaEntity,
  OperatingAreaSelectorProps,
  operatingAreasSelector,
  useGetAllOperatingAreasQuery
} from "@ots-frontend/ots-data";
import {BaseOperatingAreaMultiSelect, BaseOperatingAreaMultiSelectProps} from "./BaseOperatingAreaMultiSelect";
import {useMemo, useState} from "react";
import {Box, Button, Modal, ModalProps} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type OperatingAreaMultiSelectProps = Omit<BaseOperatingAreaMultiSelectProps, "entities" | "loading"> & {
  selector?: OperatingAreaSelectorProps
}

export const OperatingAreaMultiSelect = (props: OperatingAreaMultiSelectProps) => {
  const {
    selector,
    ...rest
  } = props;

  const selectOperatingAreas = useMemo(() => {
    return operatingAreasSelector()
  }, []);

  const {operatingAreas, isLoading} = useGetAllOperatingAreasQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      operatingAreas: selectOperatingAreas(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseOperatingAreaMultiSelect entities={operatingAreas} loading={isLoading} {...rest} />;
};

export interface OperatingAreaMultiSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: OperatingAreaMultiSelectProps,
  onSubmit?: (operatingAreas: OperatingAreaEntity[] | undefined) => void
}

export const OperatingAreaMultiSelectModal = (props: OperatingAreaMultiSelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedOperatingAreas, setSelectedOperatingAreas] = useState<OperatingAreaEntity[]>([])

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest}>
      <Box>
        <OperatingAreaMultiSelect
          {...select}
          onEntityChange={e => setSelectedOperatingAreas(e)}/>
        <Button type="submit" mt="xl" onClick={(e) => {
          if (onSubmit) {
            onSubmit(selectedOperatingAreas);
          }
        }}>
          {t("common.action.submit")}
        </Button>
      </Box>
    </Modal>
  );
};
